module.exports = "/static/fonts/OpenSans-LightItalic.ttf";